import { render, staticRenderFns } from "./VueAuthHeader.vue?vue&type=template&id=63e70b98&scoped=true&"
import script from "./VueAuthHeader.vue?vue&type=script&lang=js&"
export * from "./VueAuthHeader.vue?vue&type=script&lang=js&"
import style0 from "./VueAuthHeader.vue?vue&type=style&index=0&id=63e70b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e70b98",
  null
  
)

export default component.exports